<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    width="62"
    height="62"
    viewBox="0 0 62 62"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31 54.25C43.8406 54.25 54.25 43.8406 54.25 31C54.25 18.1594 43.8406 7.75 31 7.75C18.1594 7.75 7.75 18.1594 7.75 31C7.75 43.8406 18.1594 54.25 31 54.25Z"
      :stroke="clr ? clr : '#DFE0E2'"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M41.334 41.334C41.0328 40.5777 40.5656 39.8987 39.967 39.347C38.9614 38.4123 37.6399 37.8919 36.267 37.89H25.738C24.3628 37.8909 23.0387 38.4113 22.031 39.347V39.347C21.4348 39.9002 20.9689 40.5789 20.667 41.334"
      :stroke="clr ? clr : '#DFE0E2'"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M31.001 32.293C34.2114 32.293 36.814 29.6904 36.814 26.48C36.814 23.2696 34.2114 20.667 31.001 20.667C27.7906 20.667 25.188 23.2696 25.188 26.48C25.188 29.6904 27.7906 32.293 31.001 32.293Z"
      :stroke="clr ? clr : '#DFE0E2'"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
